// Values shared by client, server and scripts. Anything environment-specific lives in src/server/env.ts.

export const LIVE_MODEL_DEFAULT = 'gemini-3.8-live';
// Ephemeral tokens are served from v1alpha; keep the version in one place.
export const LIVE_API_VERSION = 'v1alpha';

export const INPUT_SAMPLE_RATE = 16_000;
export const OUTPUT_SAMPLE_RATE = 24_000;

export const ALLOWED_HOSTED_DOMAIN = 'stimuler.tech';
// Set with Hono's prefix: 'host', so the browser sees __Host-fuse_sid (Secure, Path=/, no Domain).
export const SESSION_COOKIE = 'fuse_sid';

// Text LLM for server tools and the conversation driver. Gemini by default: same key as Live, already billed.
export const GEMINI_TEXT_MODELS = {
  fast: 'gemini-3.8-flash',
  smart: 'gemini-pro-latest',
} as const;

// Bedrock Claude is opt-in (LLM_PROVIDER=bedrock) until the account's Marketplace payment instrument is fixed.
// Called cross-region: ap-south-1 fails first (India seller-of-record path). See ADR-0004.
export const BEDROCK_REGION = 'us-east-1';

export const BEDROCK_MODELS = {
  smart: 'global.anthropic.claude-sonnet-5',
  fast: 'global.anthropic.claude-haiku-4-5-20251001-v1:0',
} as const;
